import { Component } from '@angular/core';

@Component({
    selector: 'app-limited-access',
    templateUrl: './limited-access.component.html',
    styleUrls: ['./limited-access.component.less'],
    standalone: false
})
export class LimitedAccessComponent {}
